import React from 'react';
import styled from 'styled-components';
import { Typography } from '@fupa/fupa-uikit';
const HintTypography = styled(Typography).withConfig({
  componentId: "sc-fn56by-0"
})(["&&&{text-decoration:underline;color:inherit;cursor:pointer;}"]);
export default function LoginHint() {
  const handleLoginClick = () => {
    // @ts-ignore
    window.location = "/auth/login?redirectUrl=".concat(encodeURIComponent(window.location.pathname));
  };
  return /*#__PURE__*/React.createElement("span", {
    onClick: handleLoginClick,
    "data-sentry-component": "LoginHint",
    "data-sentry-source-file": "LoginHint.tsx"
  }, /*#__PURE__*/React.createElement(HintTypography, {
    variant: "caption-error",
    "data-sentry-element": "HintTypography",
    "data-sentry-source-file": "LoginHint.tsx"
  }, "Hier geht's zum Login"));
}